import { useMemo } from "react";
import { ChangeRequestModalTypes } from "@enums/change-request-modal-types";
import { ChangeRequestModal } from "../change-request-modal/change-request-modal";
import { IdentityProviderChangeRequestResponse } from "@idw-types/data/identity-providers";

type CreateIdentityProviderChangeRequestModalProps = {
    identityProviderName: string;
    onSubmitHandler: (onModalClose: () => void) => Promise<IdentityProviderChangeRequestResponse>;
    onModalClose: () => void;
};

export const CreateIdentityProviderChangeRequestModal = (props: CreateIdentityProviderChangeRequestModalProps) => {
    const {
        identityProviderName,
        onSubmitHandler,
        onModalClose
    } = props;

    const bodyElement = useMemo(() => {
        return (
            <div>
                <p>This action will <b>CREATE</b> a new Change Request to MODIFY the Identity Provider named <b>{identityProviderName}</b>.</p>
                <p>
                    When you have finished modifying the Identity Provider, SUBMIT the Change Request for review to continue the process.
                    You may also CANCEL the Change Request at any time prior to deployment using the CANCEL option.
                </p>
            </div>
        );
    }, []);

    const onSubmit = async () => {
        return await onSubmitHandler(onModalClose);
    };

    return (
        <ChangeRequestModal
            changeRequestModalType={ChangeRequestModalTypes.CREATE}
            title={"Modify Identity Provider"}
            body={bodyElement}
            buttonText={"Modify Identity Provider"}
            onModalClose={onModalClose}
            onSubmit={onSubmit}
        />
    );
};